import React, { FunctionComponent, ReactNode } from "react";

type FiltersGroupProps = {
  children: ReactNode;
  label: string;
};

export const FiltersGroup: FunctionComponent<FiltersGroupProps> = ({
  children,
  label,
}) => (
  <section className="space-y-4">
    <h4 className="text-xl font-medium text-ink">{label}</h4>
    {children}
  </section>
);

/**
 * @see docs/worklog/TW-859-combos-wheel-filters/rfc.md
 * @see docs/worklog/TW-859-combos-wheel-filters/tfc.md
 */
